export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/logo-bpost.46334798.svg","height":42,"width":77,"blurWidth":0,"blurHeight":0};